<template>
  <pt-active-sign-table ref="table" class="pt-active-sign-table__withData" @getTableData="getTableData" :tableData="tableData"
  :totalNumber="totalNumber" :loading="loading" :pageSize="pageSize" :tableLabels="tableLabels">
  <slot/>
  </pt-active-sign-table>
</template>

<script>
import PtActiveSignTable from '../pt-active-sign/pt-active-sign-table/index'
export default {
  name: 'pt-active-sign-table__withData',
  components: {
    'pt-active-sign-table': PtActiveSignTable
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    paramData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    searchKey: {
      type: String
    },
    isParseSign: {
      type: Boolean
    },
    tableLabels: {
      type: Array
    },
    type: {
      type: String
    },
    isQuestionnaire: {
      type: Boolean
    }
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: null,
      tableData: null,
      loading: false
    }
  },

  watch: {
    queryParams: {
      handler: function (val) {
        if (!this.isFromRouter) {
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    },
    searchKey (val) {
      this.isOutside = true
      this.getTableData(this.page)
    },
    isParseSign (val) {
      this.isOutside = true
      this.getTableData(this.page)
    },
    isQuestionnaire (val) {
      this.isOutside = true
      this.getTableData(this.page)
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        pageableParam: {
          page: page,
          size: this.pageSize
        },
        searchKey: this.searchKey,
        type: this.type
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getSignList', data).then(res => {
        if (next) {
          next(res.data)
        } else {
          this.loading = false
        }
        this.totalNumber = res.totalNumber
        this.tableData = res.data
      }).catch(err => {
        this.loading = false
        this.$refs.table.showReTry()
        this.$message.error(err || '获取活动报名列表失败')
      })
    }
  }
}
</script>
